import { lazyGetM365Acquisition } from "../lazyFunction";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isAddinMultiAccountEnabled } from "owa-feature-flags";
import { M365AppId } from "../data/M365AppId";

export async function getLogAppId(appId: string): Promise<string> {
    let logAppId = appId;
    // if its a known appId, can be returned as is
    if (Object.values(M365AppId).includes(appId)) {
        return logAppId;
    }
    const scope = await getAcquisitionScope(appId);
    logAppId = scope === "Public" ? appId : `3rdPartyApp-${scope}`;
    return logAppId;
}

async function getAcquisitionScope(appId: string): Promise<string> {
    const mailboxInfo = getModuleContextMailboxInfo();
    const { acquisition } = await lazyGetM365Acquisition.importAndExecute(appId, "cache-only", isAddinMultiAccountEnabled() ? mailboxInfo : undefined);
    return acquisition?.titleDefinition.scope ?? "unknown";
}
